export const iconFontAwesomePhotosImagesCameraRotate = (
	<i className="fa-solid fa-camera-rotate"></i>
);
